import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';

@Component({
    selector: 'bm-customer-billing-transaction-type-billing-run-type-sepa-charges',
    templateUrl: 'bm-customer-billing-transaction-type-billing-run-type-sepa-charges.component.html',
    standalone: false
})
export class BmCustomerBillingTransactionTypeBillingRunTypeSepaChargesComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() customerBillingTransactionTypeId: number;

    billingRunTypeSepaChargesWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        // NOTE: Backend entity com.mvs.backend.bm.model.BillingRunTypeSepaCharge is
        // annotated @NonCrudEntity(reason = "internal_runtime"). Per the NonCrudEntity
        // javadoc, CRUD endpoints, generic forms, and the Object Browser do NOT work
        // for this entity — so this widget's QL query will return HTTP 400 at runtime.
        // Widget kept pending backend decision (remove @NonCrudEntity, or drop tab).
        // See also config.page.ts:370-374 for the same caveat on the config-page widget.
        const filterCriteria = FilterCriteria.create(
            'e.transactionCharge.id',
            FilterCriteria.cOperatorEqual,
            this.customerBillingTransactionTypeId
        );

        this.billingRunTypeSepaChargesWidgetData = WidgetFactory.createWidgetTableEntityBasicQl(
            `bm.customer.billing.transaction.type.billing.run.type.sepa.charges.widget.data.${this.customerBillingTransactionTypeId}`,
            'SEPA-Entgelte',
            'bm.BillingRunTypeSepaCharge',
            [filterCriteria]
        );

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['customerBillingTransactionTypeId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
